module.exports = __webpack_public_path__ + "img/tajikistan.bc17f365.svg";